import { render, staticRenderFns } from "./CelulaDadosPaciente.vue?vue&type=template&id=5bdc7246&"
import script from "./CelulaDadosPaciente.vue?vue&type=script&lang=js&"
export * from "./CelulaDadosPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports